// extracted by css-extract-rspack-plugin
export default {"tooltipParent":"Nq6djuEI4wBMtvs3"};